import { Button, Col, Form, Input, Modal, Row, Space, theme } from "antd"
import React, { useEffect } from "react";
import { requiredItem } from "../../../constants/constants";

const ModalEditShop = ({ visible, onCancel, onSave, data }) => {
    const [form] = Form.useForm();
    const { token } = theme.useToken();
    const formStyle = {
        maxWidth: 'none',
        background: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        padding: 24,
    };
    const handleFinish = (values) => {
        if (values.custom_code !== data.custom_code) {
            const temp = {
                ...values,
                id: data.id
            }
            onSave(temp);
        }
        onCancel();
    };
    
    useEffect(() => {
        form.setFieldsValue({
            name: data?.shop_name,
            custom_code: data?.custom_code
        });
    }, [data]);

    return (
        <Modal
            title={"Cập nhật thông tin shop"}
            open={visible}
            onCancel={onCancel}
            width={'50%'}
            footer={null}
        >
            <Form form={form} layout="vertical" name="add-edit-account" style={formStyle} onFinish={handleFinish}>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Shop name"
                            name="name"
                            rules={requiredItem}
                        >
                            <Input disabled/>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Custom code"
                            name="custom_code"
                            rules={requiredItem}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                
                <Row gutter={16} justify={'end'}>
                    <Space>
                        <Button onClick={onCancel}>
                            Hủy
                        </Button>
                        <Button type="primary" htmlType="submit">
                            Lưu
                        </Button>
                    </Space>
                </Row>
            </Form>
        </Modal>
    )
}
export default React.memo(ModalEditShop);

